import { Component,  Input, OnInit } from '@angular/core';
import { Dictionary } from '@ngrx/entity';
import { addNewCustomQuestion, editCustomQuestion } from '../../modules/performers/performerSharedFunctions';
import { CustomQuestion, CustomQuestionType, JoiEvent, Ranking } from 'globals/store/events.data';
import { entityTypesReselector } from '../../store/reselectors/entity.reselector';
import { CoreEntityType } from 'globals/store/share.data';
import { Wrapper } from '../wrapper.component';
import { DotMenuEvent } from '../misc/dot-menu.component';
import { ConfirmDeleteData, openConfirmDeleteGetResult } from '../dialog.confirmDelete.component';
import { CustomQuestionManagerViewComponent } from './custom-question-manager-view.component';
import { UpperCasePipe } from '@angular/common';

@Component({
    selector: 'custom-question-manager',
    template: `
<custom-question-manager-view
  [questions]="questions"
  [addQuestionCopy]="'+ ADD QUESTION TO ' + (entityType | uppercase) + ' PROFILE'"
  [addTextCopy]="'+ ADD A TEXT BOX TO ' + (entityType | uppercase) + ' PROFILE'"
  (dotMenuSelection)="dotMenuSelection($event)"
  (editQuestion)="editQuestion($event)"
  (changeIdOrder)="changeIdOrder($event)"
  (addQuestion)="addQuestion($event)"

  [questionCounts]="questionCounts"
  [entityTypesMap]="entityTypesMap"
  [entityType]="entityType"
  (updateQuestionIds)="updateQuestionIds($event)"
></custom-question-manager-view>
`,
    standalone: true,
    imports: [CustomQuestionManagerViewComponent, UpperCasePipe],
})
export class CustomQuestionManagerComponent extends Wrapper<CustomQuestionManagerComponent> implements OnInit {
  @Input() entityType: CoreEntityType
  questions: CustomQuestion[] = []
  questionCounts: Dictionary<number> = {}
  entityTypesMap: Dictionary<Ranking> = {}
  event: JoiEvent


  constructor() {
    super()
    this.subProp(this.store.select('events', 'event'), 'event')
  }

  async dotMenuSelection({ dotEvent, question }: { dotEvent: DotMenuEvent, question: CustomQuestion }) {
    const count = this.questionCounts[question.id] || 0
    const data: ConfirmDeleteData = {
      title: `Delete custom question`,
      para: !count ? 'Nobody has answered it yet.' : `This was answered by ${count} ${this.entityType}${count === 1 ? '' : 's'}.  Their answers will also be lost if you delete this`,
      rect: (dotEvent.event.target as HTMLButtonElement).getBoundingClientRect(),
      dialog: this.dialog
    }
    const del = await openConfirmDeleteGetResult(data)
    if (!del) return

    const questions = this.questions.filter(q => q.id !== question.id)
    this.eventService.updateCustomQuestions(questions, this.entityType)
  }

  changeIdOrder(newIds: string[]) {
    const questions = newIds.map(id => this.questions.find(q => q.id === id))
    this.questions = questions
    this.eventService.updateCustomQuestions(questions, this.entityType)
  }

  ngOnInit() {
    this.selectCallback(entityTypesReselector, this.entityType, (data: { typesMap: Dictionary<Ranking>, questions: CustomQuestion[], questionCounts: Dictionary<number> }) => {
      if (!data) return
      this.entityTypesMap = data.typesMap
      this.questions = data.questions
      this.questionCounts = data.questionCounts
    })
  }


  getEntityTypes() {
    switch (this.entityType) {
      case 'performer':
        return this.event.performerTypes
      case 'resource':
        return this.event.resourceTypes
      case 'exhibitor':
        return this.event.exhibitorTypes
      case 'attendee':
        return this.event.attendeeTypes
      default:
        console.log(`Add question not implemented for ${this.entityType}s yet!`)
        return
    }
  }

  async editQuestion(question: CustomQuestion) {
    console.log("Should be editing... (not yet!)", question)
    editCustomQuestion(this.entityType, question, this.questions, this.getEntityTypes(), this.dialog, this.eventService)
  }

  updateQuestionIds({ question, ids }: { question: CustomQuestion, ids: string[] }) {
    this.questions.find(q => q.id === question.id).typeIds = ids
    this.eventService.updateCustomQuestions(this.questions, this.entityType)
  }

  async addQuestion(questionType: CustomQuestionType | undefined) {
    const entityTypes = this.getEntityTypes()
    if (!entityTypes) return

    addNewCustomQuestion(this.entityType, entityTypes, this.dialog, this.eventService, questionType)
  }

}

